import { __ } from '../i18n.js';
import { recaptchaSiteKey } from '../lib/recaptcha.js';

/**
 * Google's required attribution, shown only when reCAPTCHA is active.
 * The v3 badge is hidden via CSS (theme.css), which Google's FAQ allows
 * ONLY if this text is included in the user flow instead — removing
 * this line means unhiding the badge.
 *
 * Moved out of AuthScreen (its original home) once the reset-password
 * screen needed the identical notice; the strings are byte-for-byte the
 * same, so the .pot is unaffected by the move.
 */
export default function RecaptchaNotice() {
  if (!recaptchaSiteKey()) {
    return null;
  }
  return (
    <p class="etm-field-hint etm-recaptcha-notice">
      {__('Deze site wordt beschermd door reCAPTCHA; het ', 'etm')}
      <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
        {__('Privacybeleid', 'etm')}
      </a>
      {__(' en de ', 'etm')}
      <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
        {__('Servicevoorwaarden', 'etm')}
      </a>
      {__(' van Google zijn van toepassing.', 'etm')}
    </p>
  );
}
